import { retrieveFromStorage } from "../Components/Functions";
import { USER_AUTHENTICATION_DATA } from "../Redux/User/types";

const { business = {} } = retrieveFromStorage(USER_AUTHENTICATION_DATA)||{};

export const routers =  {
    dashboard: {
        base: "/dashboard/",
        appointments: "/dashboard/appointments",
        scheduler: "/dashboard/scheduler",
        favourites: "/dashboard/favourites",
        patients: "/dashboard/patients",
        services: "/dashboard/my-services",
        chats: "/dashboard/messanger",
        settings: "/dashboard/settings",
        profile: "/dashboard/profile",
        wallet: "/dashboard/wallet",
        permissions: "/dashboard/permissions",
        messanger:(username) => { return `/dashboard/messanger/${username}` },
        newconversation: {
            name: "new-conversation",
            url: `/dashboard/messanger/new-conversation`
        },
        medicalhistory: "/dashboard/medical-history",
        medicalrecord: "/dashboard/medical-record",
        medicalrecord_2nd: "/medical-2nd-opinion/patient-medical-record/:identifier",
        medicalrecord_2nd_admin: "/medical-2nd-opinion/patient-medical-record-admin/:identifier",
        patient_record_view: (identifier) => { return `/dashboard/patient-record/${identifier}` },
    },
    admin: {
        app_view: "/admin/doctor-profile/:identifier/:view_name"
    },
    others: {
        video_call: (id) => `/meeting/${id}`
    },
    specialist: {
        dashboard: "/dashboard",
    },
    map: {
        base: `/${business?.identity}/map`,
        base_route: '/:business_id/map',
        admin: "/map/admin",
    },
    orders: {
        base: "/orders",
        new_order: "/orders/new-order",
        invoice: (id) => {
            return `/orders/invoice/${id}`
        },
        list: (type) => {
            return `/orders${type}`
        }
    },
    users: {
        base: "/users",
        list: (type, filter) => {
            return `/users/${type}${filter}`
        },
        new_rider: "/users/riders/add-new-rider"
    },
    settings: {
        base: "/settings",
        config: (page) => {
            return `/settings/${page}`
        },
        rate: "/settings/rate-delivery-config",
        fixedrate: "/settings/fixed-location-config",
        map: "/settings/map-config",
        rider: "/settings/rider-config",
        payment: "/settings/payment-config"
    },
    account: {
        base: "/account",
        config: (page) => {
            return `/account/${page}`
        },
        profile: "/account/profile",
        business: "/account/business-profile",
        billing: "/account/wallet-overview"
    },
    auth: {
        login: "/login",
        register: "/register",
        password_reset: "/password_reset",
        password_reset_confirm: "/password_reset_confirm/:pin/:secret",
    },
    pages: {
        home: "/",
        becomespecialist: "/become-a-specialist",
        search: (params) => {
            return `/search${params ? "?"+ new URLSearchParams(params).toString().toLowerCase() : ""}`
        },
        searchv2: (params) => {
            return `/searchv2${params ? "?"+ new URLSearchParams(params).toString().toLowerCase() : ""}`
        },
        doctor: (id) => {
            return `/doctor/${id}`
        },
        hospital: (id) => {
            return `/hospital/${id}`
        },
        tos: "https://evokeehealth.com/p/terms-of-services"
    },
}
